import React, { forwardRef } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { getSourceScenes } from "../../../../store/features/scenesSlice";
import { setScenesData } from "../../../../utils/setdata";
import { IScene } from "../../../../types/interface";
import { showPopupType } from "../../Sidebar";

type ScenesProps = {
  show: boolean;
  onShow: React.Dispatch<React.SetStateAction<showPopupType>>;
};

const Scenes = forwardRef<HTMLDivElement, ScenesProps>(
  ({ show = false, onShow }: ScenesProps, ref) => {
    const dispatch = useDispatch();
    const handleChangeScene = (currentScene: IScene) => {
      dispatch(getSourceScenes(currentScene));
    };

    return (
      <StyledSecenes
        ref={ref}
        style={{ display: show ? "" : "none" }}
        className="absolute  w-[350px] z-50 p-3 rounded-md bg-alphaBg top-2/4 -translate-y-2/4 right-0"
      >
        <div className="max-h-[600px]  flex flex-col gap-y-3 has-scrollbar">
          <div className="flex mb-4 justify-between items-center">
            <h3 className="text-secondary text-xl  font-semibold">Scenes</h3>
            <div
              onClick={() =>
                onShow((prev) => {
                  return {
                    ...prev,
                    showScenesPopup: !prev.showScenesPopup,
                  };
                })
              }
              className="hover:text-white cursor-pointer select-none text-textSecondary"
            >
              <i className="bi text-2xl cursor-pointer text-inherit bi-dash-lg"></i>
            </div>
          </div>
          {setScenesData.map((scene) => {
            return (
              <div
                onClick={() => handleChangeScene(scene)}
                key={scene.id}
                className="relative cursor-pointer select-none h-[190px] flex-shrink-0 overflow-hidden rounded-lg"
              >
                <img
                  className="rounded-lg object-cover h-[190px]"
                  src={scene.thumbnail}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </StyledSecenes>
    );
  }
);

export default React.memo(Scenes);
const StyledSecenes = styled.div`
  &.close {
    display: none;
  }
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  z-index: 100;
  right: 41px;
`;
